import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  subWeeks,
  subMonths,
  subYears,
} from "date-fns";

/**
 * Get the start and end dates based on the quick selection string
 * @param selection - The quick selection string
 * @returns a tuple of two dates: [startDate, endDate]
 */
export default function getDatesBasedOnQuickSelection(selection: string) {
  let startDate: Date | undefined;
  let endDate: Date | undefined;

  switch (selection) {
    case "today":
      startDate = new Date();
      endDate = new Date();
      break;
    case "yesterday":
      startDate = new Date();
      startDate.setDate(startDate.getDate() - 1);
      endDate = startDate;
      break;
    case "this_week":
      startDate = startOfWeek(new Date(), { weekStartsOn: 0 }); // Assuming week starts on Monday
      endDate = endOfWeek(new Date(), { weekStartsOn: 0 });
      break;
    case "last_week":
      startDate = startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 });
      endDate = endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 });
      break;
    case "this_month":
      startDate = startOfMonth(new Date());
      endDate = endOfMonth(new Date());
      break;
    case "last_month":
      startDate = startOfMonth(subMonths(new Date(), 1));
      endDate = endOfMonth(subMonths(new Date(), 1));
      break;
    case "this_year":
      startDate = startOfYear(new Date());
      endDate = endOfYear(new Date());
      break;
    case "last_year":
      startDate = startOfYear(subYears(new Date(), 1));
      endDate = endOfYear(subYears(new Date(), 1));
      break;
    default:
      break;
  }
  return { from: startDate, to: endDate };
}
